import { AnimatedSection } from '@/components/ui';
import { BrainCircuit, MessageCircleHeart } from 'lucide-react';

// Credibility section — no customer quotes yet, so this leans on real, verifiable
// facts. Swap these cards for testimonials as soon as the first real customer
// quotes come in.
const PROOF_POINTS = [
  {
    Icon: BrainCircuit,
    title: 'Powered by leading AI models',
    desc: 'Answers are generated by various leading large language models, trained on your business content.',
  },
  {
    Icon: MessageCircleHeart,
    title: 'Founder-level support',
    desc: 'Every setup question gets answered by the person who built the product.',
  },
];

export const SocialProof = () => (
  <AnimatedSection className="border-y border-border bg-muted/20 py-10 md:py-12">
    <div className="container">
      <div className="mx-auto grid max-w-3xl grid-cols-1 gap-8 sm:grid-cols-2 md:gap-6">
        {PROOF_POINTS.map(({ Icon, title, desc }) => (
          <div key={title} className="flex items-start gap-4">
            <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl border border-primary/20 bg-background shadow-sm shadow-primary/10">
              <Icon className="h-5 w-5 text-primary" aria-hidden="true" />
            </div>
            <div>
              <h3 className="text-sm font-bold text-foreground">{title}</h3>
              <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </AnimatedSection>
);
